<template>
  <div>
    <tabs
      v-model="active"
      color="#4FD9D5"
      title-active-color="#4FD9D5"
      title-inactive-color="#999999"
      line-width="25%"
      :border="true"
      sticky
    >
      <tab v-for="(item, index) in tabs" :key="index" :title="item" >
        <list
          v-model="loading"
          :finished="finished"
          :finished-text="finishedText"
          @load="onLoad"
        >
          <posts
            :list="list"
            @lookMsg="lookMsg"
            @lookMore="lookMore"
            @lookMore1="lookMore1"
            @openShare="openShare"
            :showTitleLen="showTitleLen"
          />
        </list>
        <div v-if="active == 1" class="change" @click="getList">换一批</div>
      </tab>
    </tabs>

    <div class="edit-btn" @click="$router.push('fb')">
      <i class="iconfont icon-bi"></i>
    </div>
  </div>
</template>

<script>
/**
@description:
@createTime:2021-08-16
@create:wq
*/
import { Tab, Tabs, List } from "vant";
import posts from "../../components/posts.vue";

export default {
  name: "",
  props: {},
  components: { Tab, Tabs, posts, List },
  data() {
    return {
      active: 1,
      // tabs: ["关注", "推荐", "最新", "悬赏"],
      tabs: ["关注", "推荐", "最新"],
      page: 1,
      list: [],
      loading: false,
      finished: false,
      finishedText: "没有更多了",
      showInput: false,
      sendText: "",
      shareMask: false,
      shareId:'',
      begin:true,
      userinfo: JSON.parse(localStorage.getItem("user")),
      showTitleLen:20,//显示文章的字数
    };
  },
  computed: {},
  watch: {
    active(data) {
      this.loading = false;
      this.finished = false;
      this.page = 1;
      this.list = [];
      if (data == 1) {
        this.finishedText = "";
      } else {
        this.finishedText = "没有更多了";
      }
      this.getList();
    },
  },
  mounted() {},
  created() {
    this.begin = true;
    if(this.userinfo){
      this.msgPageNum()
    }
  },
  methods: {
    lookMsg(i){
      if(this.list[i].titleFlag){
        this.list[i].title = this.list[i].allTitle
      }else{
        this.list[i].title = this.list[i].title.substring(0,this.showTitleLen) + '...'
      }
      this.list[i].titleFlag = !this.list[i].titleFlag;
    },
    msgPageNum(){
      this.api.msgPageNum().then(res => {
        this.$store.dispatch("app/setNum", res.data.msgPageNum);
      })
    },
    lookMore(i) {
      this.list[i].commentList = JSON.parse(
        JSON.stringify(this.list[i].commentListAll)
      );
    },
    lookMore1(i) {
      let cList = JSON.parse(JSON.stringify(this.list[i].commentListAll));
      this.list[i].commentList = cList.splice(0, 2);
    },
    closeShareMask() {
      this.shareMask = false;
    },
    openShare(item) {
      this.shareMask = true;
      this.shareId = item;
    },
    getList() {
      let data = { page: this.page, type: this.active };
      if (this.active == 1) {
        data = { type: this.active };
        this.finishedText = "";
        this.list = [];
      }
      this.api.communityList(data).then((res) => {
        this.list = [...this.list, ...res.data.data];
        this.list.map((r) => {
          let coList = JSON.parse(JSON.stringify(r.commentList));
          if (coList.length > 2) {
            r.commentListAll = r.commentList;
            r.commentList = coList.splice(0, 2);
            // console.log(coList.splice(0, 2));
          }
          r.allTitle = JSON.parse(JSON.stringify(r.title));
          r.titleFlag = false
          if(r.title && r.title.length > this.showTitleLen){
            r.title = r.title.substring(0,this.showTitleLen) + '...'
            r.titleFlag = true;
          }
        });
        if (res.data.to < res.data.per_page) {
          this.loading = true;
          this.finished = true;
        } else {
          this.loading = false;
        }
        if(this.active == 1){
          this.begin = false
        }
      });
    },
    onLoad() {
      if (this.active != 1 || (this.active == 1 && this.begin)) {
        this.getList();
        this.page++;
      }else{
        this.loading = false
        return
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.gz {
  padding: 0.24rem 0.24rem 0;
  border-bottom: 0.12rem solid #f1f1f1;
  .gz-user {
    display: flex;
    align-items: flex-end;
    .gz-user-img {
      width: 0.8rem;
      height: 0.8rem;
      border-radius: 50%;
      overflow: hidden;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 8px;
      img {
        width: 100%;
      }
    }
    .gz-user-info {
      flex: 1;
      .gz-user-name {
        font-size: 0.32rem;
        font-weight: 400;
        color: #333333;
      }
      .gz-time {
        font-size: 0.24rem;
        font-weight: 400;
        color: #cccccc;
      }
    }
    .is-gz {
      .gz-btn {
        width: 1.3rem;
        height: 0.6rem;
        background: rgba(79, 217, 213, 0.1);
        border: 1px solid #4fd9d5;
        border-radius: 0.3rem;
        font-size: 0.26rem;
        font-weight: 400;
        color: #4fd9d5;
        display: flex;
        align-items: center;
        justify-content: center;
        i {
          margin-right: 3px;
        }
      }
      .ygz-btn {
        width: 1.54rem;
        height: 0.6rem;
        background: rgba(188, 188, 188, 0.1);
        border: 1px solid #cccccc;
        border-radius: 0.3rem;
        font-size: 0.26rem;
        font-weight: 400;
        color: #999999;
        display: flex;
        align-items: center;
        justify-content: center;
        i {
          margin-right: 3px;
        }
      }
    }
  }
  .gz-text {
    margin-top: 0.24rem;
    font-size: 0.28rem;
    font-weight: 400;
    color: #666666;
  }
  .gz-img {
    margin-top: 0.16rem;
    display: flex;
    flex-wrap: wrap;
    > div {
      width: 2.3rem;
      height: 2.3rem;
      margin-right: 0.06rem;
      margin-bottom: 0.06rem;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 0.1rem;
      overflow: hidden;
      img {
        width: 100%;
      }
      &:nth-child(3n) {
        margin-right: 0;
      }
    }
  }
  .gz-video {
    margin-top: 0.16rem;
    max-width: 100%;
    border-radius: 0.1rem;
    overflow: hidden;
    video {
      width: 100%;
    }
  }
  .three-l {
    display: flex;
    align-items: center;
    padding: 6px 0;
    margin-top: 0.24rem;
    border-top: 1px solid #f0f0f0;

    > div {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 0.26rem;
      font-weight: 400;
      color: #999999;
      i {
        margin-right: 4px;
      }
    }
  }
}
.edit-btn {
  background: #4fd9d5;
  position: fixed;
  bottom: 60px;
  right: 10px;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 0 5px #4fd9d5;
  i {
    color: white;
    font-size: 18px;
  }
}
.change {
  text-align: center;
  padding-top: 20px;
  color: #666666;
  font-size: 0.28rem;
}
</style>
